export class Reports {
    public static readonly BalanceReport: string = "BALANCE_REPORT";
    public static readonly GameReport: string = "GAME_REPORT";
    public static readonly TerminalReport: string = "TERMINAL_REPORT";
}